export const WIZARD_PREVIOUS = '[Wizard] Previous'
export const WIZARD_NEXT = '[Wizard] Next'
export const WIZARD_ANSWER = '[Wizard] Answer'



// WEBPACK FOOTER //
// ./src/js/quiz/state/actions/Wizard.actions.jsx